// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__25Zp4","addWidgetButton":"Header_addWidgetButton__3sHKi","dashboardTabs":"Header_dashboardTabs__1C_75","active":"Header_active__3Ka3E"};